import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import NewFeatures from '../components/NewFeatures/NewFeatures';

export const newFeaturesRoutes = (
  <Route path="/new-features" element={<MainLayout />}>
    <Route index element={<NewFeatures />} />
  </Route>
);
